import React, { useState } from "react";
import FuseAnimate from '@fuse/core/FuseAnimate';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FuseChipSelect from '@fuse/core/FuseChipSelect';
import UsDateField from 'app/main/components/UsDateField';
import { makeStyles } from "@material-ui/core";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming'
];

const stateOptions = US_STATES.map(state => ({
  value: state,
  label: state
}));

const useStyles = makeStyles({
  fuseChipMobile: {
    WebkitTextSizeAdjust: '100%',
    '& *': {
      WebkitTextSizeAdjust: '100%'
    },

    '& [class*="makeStyles-placeholder"]': {
      fontSize: '12px !important',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    '& [class*="singleValue"], & .Select-value-label': {
      fontSize: '12px !important',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }
});


export default function OnboardingPage() {

  const isMobile = useMediaQuery('(max-width:500px)');
  const classes = useStyles();


  const style = {
    conteiner: { display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f5f5f5', padding: isMobile ? '10px 10px 30px 10px' : '20px 20px 40px 20px'},
    formBox: { width: '100%', maxWidth: '600px', background: 'white', padding: isMobile ? '15px' : '30px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)'},
    field: { marginBottom: "20px", display: "flex", flexDirection: "column"},
    input: { padding: "10px", borderRadius: "8px", border: "1px solid #ccc", marginTop: "5px"},
    button: { marginTop: "15px", padding: "12px 20px", background: "#cf1e2b", color: "black", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: '16px'},
    buttonContainer: { display: "flex", justifyContent: "center", marginTop: "20px"},
    title: { fontFamily: "Arial, sans-serif", paddingTop: "15px", paddingBottom: "10px"}
  }

  const [ submitted, setSubmitted ] = useState(false);

  const [ formData, setFormData ] = useState({
    name:"",
    surname:"",
    phone_number:"",
    personal_email:"",
    iloanEmail:"",
    street: "",
    street2: "",
    city: "",
    state: "",
    birthdate: "",
    starting_date: "",
    emergency_contact_phone: "",
    emergency_contact_name: "",
    business_phone_number: "",
    zipcode:"",
    position: "",
    stateLicenses: [{ state: "", number: "" }]
  })

  const [errors, setErrors] = useState({
    phone_number: "",
    personal_email: "",
    state: ""
  });



  const inputResponsive = {
    InputProps: {
    style: {
      fontSize: isMobile ? '12px' : '14px'
    }
    },
    InputLabelProps: {
      style: {
        fontSize: isMobile ? '12px' : '14px'
      }
    }
  }


  const handleAddStateLicense = () => {
  setFormData(prev => ({
    ...prev,
    stateLicenses: [...prev.stateLicenses, { state: "", number: "" }]
  }));
};

const handleRemoveStateLicense = (index) => {
  setFormData(prev => ({
    ...prev,
    stateLicenses: prev.stateLicenses.filter((_, i) => i !== index)
  }));
};

const handleStateLicenseChange = (index, field, value) => {
  setFormData(prev => ({
    ...prev,
    stateLicenses: prev.stateLicenses.map((lic, i) =>
      i === index ? { ...lic, [field]: value } : lic
    )
  }));
};


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === "personal_email" && { iloanEmail: value })
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (name === "phone_number") {
      if (!/^[0-9]{6,}$/.test(value)) {
        error = "Please enter a valid phone number";
      }
    }

    if (name === "personal_email") {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = "Please enter a valid email address";
      }
    }

    if (error) {
      setErrors(prev => ({
        ...prev,
        [name]: error
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (errors.phone_number || errors.personal_email) {
      return;
    }

    if (!formData.state) {
      setErrors(prev => ({
        ...prev,
      state: "State is required"
    }));
    return;
    }

    try {
      console.log("submitted front", formData);

      const res = await fetch(`${API_URL}v1/onboarding`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      console.log("status:", res.status);
      const data = await res.json();
      console.log("Onboarding back enviado:", data);

      setSubmitted(true);

      setFormData({
        name: "",
        surname: "",
        phone_number: "",
        personal_email: "",
        iloanEmail: "",
        street: "",
        street2: "",
        city: "",
        state: "",
        birthdate: "",
        starting_date: "",
        emergency_contact_phone: "",
        emergency_contact_name: "",
        business_phone_number: "",
        zipcode: "",
        position: "",
        stateLicenses: [{ state: "", number: "" }]
      });

      setErrors({
        phone_number: "",
        personal_email: ""
      });

    } catch (error) {
      console.error("Error enviando onboarding:", error);
    }
  };

  return (
    <div style={style.conteiner}>
      <div>
        <form style={style.formBox}
          onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
            e.preventDefault();
            }
          }}
        >
          <h1 className="mt-1 mb-16" style={{fontFamily:'Arial, sans-serif'}}>Onboarding Form</h1>
          <p className="mt-8 mb-16" style={{fontFamily:'Arial, sans-serif'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="name"
            name="name"
            label="First Name"
            variant="outlined"
            value={formData.name}
            onChange={handleChange}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="surname"
            name="surname"
            label="Last Name"
            variant="outlined"
            value={formData.surname}
            onChange={handleChange}
            {...inputResponsive}
          />

          <UsDateField
            fullWidth
            required
            className="mt-8 mb-16"
            id="birthdate"
            name="birthdate"
            label="Birthdate"
            InputLabelProps={{
              shrink: true,
              style: {
              fontSize: isMobile ? '12px' : '14px'
              }
            }}
            value={formData.birthdate}
            onChange={handleChange}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="phone_number"
            name="phone_number"
            label="Personal Phone Number"
            variant="outlined"
            type="tel"
            value={formData.phone_number}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(errors.phone_number)}
            helperText={errors.phone_number}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="business_phone_number"
            name="business_phone_number"
            label="Business Phone Number"
            variant="outlined"
            type="tel"
            value={formData.business_phone_number}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(errors.phone_number)}
            helperText={errors.phone_number}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="personal_email"
            name="personal_email"
            label="Personal Email Address"
            variant="outlined"
            type="email"
            value={formData.personal_email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(errors.personal_email)}
            helperText={errors.personal_email}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="street"
            name="street"
            label="Address Line 1"
            variant="outlined"
            value={formData.street}
            onChange={handleChange}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="street2"
            name="street2"
            label="Address Line 2"
            variant="outlined"
            value={formData.street2}
            onChange={handleChange}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="city"
            name="city"
            label="City"
            variant="outlined"
            value={formData.city}
            onChange={handleChange}
            {...inputResponsive}
          />

          <div className={isMobile ? classes.fuseChipMobile : ''}>
          <FuseChipSelect
            required
            id="state"
            name="state"
            placeholder="State"
            isMulti={false}
            className="w-full flex-1 mt-8 mb-16"
            value={ formData.state ? { value: formData.state, label: formData.state } : null }
            {...inputResponsive}
            onChange={selected => {
            const value = selected ? selected.value : "";

            setFormData(prev => ({
              ...prev,
              state: value
            }));

            setErrors(prev => ({
              ...prev,
              state: value ? "" : "State is required"
            }));
          }}
            options={stateOptions}
            textFieldProps={{
              label: 'State',
              required: true,
              error: Boolean(errors.state),
              helperText: errors.state,
              InputLabelProps: {
                shrink: true, style: { fontSize: isMobile ? '12px' : '14px' }
              },
              variant: 'outlined'
            }}
            menuPosition="absolute"
            menuShouldScrollIntoView={false}
            menuPlacement="auto"

            styles={{
              control: base => ({
                ...base,
                minHeight: 54,
                height: 54
              }),
              valueContainer: base => ({
                ...base,
                height: 54,
                paddingTop: 0,
                paddingBottom: 0
              }),
              indicatorsContainer: base => ({
                ...base,
                height: 54
              }),

              option: base => ({
                ...base,
                height: 32,
                minHeight: 32,
                maxHeight: 32,
                padding: '6px 12px',
                fontSize: isMobile ? '12px' : '14px',
                lineHeight: '20px',
                boxSizing: 'border-box'
              }),

              menuList: base => ({
                ...base,
                maxHeight: isMobile ? 180 : 140,
                paddingTop: 0,
                paddingBottom: 0,
                marginTop: -10,
                overflowY: 'auto'
              }),

              singleValue: base => ({
                ...base,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }),

              menuPortal: base => ({
                ...base,
                zIndex: 9999
              })
            }}

          />
          </div>

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="zipcode"
            name="zipcode"
            label="Zipcode"
            variant="outlined"
            value={formData.zipcode}
            onChange={handleChange}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="emergency_contact_name"
            name="emergency_contact_name"
            label="Emergency Contact Name"
            variant="outlined"
            value={formData.emergency_contact_name}
            onChange={handleChange}
            {...inputResponsive}
          />

          <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="emergency_contact_phone"
            name="emergency_contact_phone"
            label="Emergency Contact Phone"
            variant="outlined"
            type="tel"
            value={formData.emergency_contact_phone}
            onChange={handleChange}
            {...inputResponsive}
          />

          <UsDateField
            fullWidth
            required
            className="mt-8 mb-16"
            id="starting_date"
            name="starting_date"
            label="Starting Date"
            value={formData.starting_date}
            onChange={handleChange}
          />

            <TextField
            fullWidth
            required
            className="mt-8 mb-16"
            id="position"
            name="position"
            label="Position"
            variant="outlined"
            value={formData.position}
            onChange={handleChange}
            {...inputResponsive}
          />

<h3 style={style.title}>Licensed State</h3>

{formData.stateLicenses.map((license, index) => (
  <div
    key={index}
    className="flex gap-12 mt-8 mb-16"
  >

    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '20px',
        marginBottom: '20px'
      }}
    >

      <div
        className={isMobile ? classes.fuseChipMobile : ''}
        style={{ flex: 1, minWidth: 0 }}
      >
        <FuseChipSelect
          isMulti={false}
          className="w-full"
          value={
            license.state
              ? { value: license.state, label: license.state }
              : null
          }
          options={stateOptions}
          onChange={sel =>
            handleStateLicenseChange(index, 'state', sel?.value || '')
          }
          textFieldProps={{
            label: 'State',
            variant: 'outlined',
            InputLabelProps: { shrink: true }
          }}
          styles={{
            control: base => ({
              ...base,
              minHeight: 54,
              height: 54
            }),
            valueContainer: base => ({
              ...base,
              height: 54,
              paddingTop: 0,
              paddingBottom: 0
            }),
            indicatorsContainer: base => ({
              ...base,
              height: 54
            }),

            option: base => ({
              ...base,
              height: 32,
              minHeight: 32,
              maxHeight: 32,
              padding: '6px 12px',
              fontSize: isMobile ? '12px' : '14px',
              lineHeight: '20px',
              boxSizing: 'border-box'
            }),

            menuList: base => ({
              ...base,
              maxHeight: isMobile ? 180 : 140,
              paddingTop: 0,
              paddingBottom: 0,
              marginTop: -10,
              overflowY: 'auto'
            }),

            singleValue: base => ({
              ...base,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }),

            menuPortal: base => ({
              ...base,
              zIndex: 9999
            })
          }}

          menuShouldScrollIntoView={false}
          menuPlacement="top"
          menuPosition="absolute"
        />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <TextField
          fullWidth
          label={isMobile ? 'Number' : 'License Number'}
          variant="outlined"
          value={license.number}
          onChange={e =>
            handleStateLicenseChange(index, 'number', e.target.value)
          }
          {...inputResponsive}
          InputProps={{
            style: { height: 54 }
          }}
        />
      </div>
    </div>

    <div
      style={{
        display: 'flex',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: '4px',
        paddingBottom: '20px'
      }}
    >
      {index === formData.stateLicenses.length - 1 && (
        <IconButton
          onClick={handleAddStateLicense}
          style={{
            padding: isMobile ? 4 : 15,
            marginTop: isMobile ? 15 : 0
          }}
        >
          <Icon>add</Icon>
        </IconButton>
      )}
      {formData.stateLicenses.length > 1 && (
        <IconButton
          onClick={() => handleRemoveStateLicense(index)}
          style={{
            padding: isMobile ? 4 : 15,
            marginTop: isMobile ? 15 : 0
          }}
        >
          <Icon>close</Icon>
        </IconButton>
      )}
    </div>
  </div>
))}



          <div style={style.buttonContainer}>
            <FuseAnimate animation="transition.slideRightIn" delay={300}>
              <Button
                type="submit"
                disabled={submitted}
                className="whitespace-no-wrap normal-case"
                variant="contained"
                color="secondary"
                style={{
                  opacity: submitted ? 0.6 : 1,
                  cursor: submitted ? "not-allowed" : "pointer",
                  paddingTop: "50px"
                }}
              >
                <span>Submit</span>
              </Button>
            </FuseAnimate>
          </div>



          <div>{submitted && (
              <p style={{ marginTop: "15px", color: "green", textAlign: "center" }}>Thank you! A member of our team will contact you to follow up the onboarding process</p>
            )}
          </div>


        </form>
      </div>
    </div>
  )
}
